import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';

const SITE_NAME = 'Darkar Company';
const SITE_URL = 'https://darkarcompany.com';
const DEFAULT_DESCRIPTION = 'Contenido original de Darkar Company Studios - Shows, Música, Juegos y más';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache for site settings
let cachedSettings = null;

export const MetaTags = ({ 
  title, 
  description, 
  image, 
  url,
  type = 'website'
}) => {
  const [siteSettings, setSiteSettings] = useState(cachedSettings);

  useEffect(() => {
    if (!cachedSettings) {
      fetch(`${API}/site-settings`)
        .then(res => res.json())
        .then(data => {
          cachedSettings = data;
          setSiteSettings(data);
        })
        .catch(() => {});
    }
  }, []);

  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const metaDescription = description || siteSettings?.tagline || DEFAULT_DESCRIPTION;
  const metaImage = image || siteSettings?.og_image || '';
  const metaUrl = url ? `${SITE_URL}${url}` : SITE_URL;

  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      {metaImage && <meta property="og:image" content={metaImage} />}
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={metaUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {metaImage && <meta name="twitter:image" content={metaImage} />}
    </Helmet>
  );
};
